import { Chip, ChipProps, Icon } from '@mui/material';

import { ProspectStatusChipProps, prospectStatusConfigMap } from './types';

export const ProspectStatusChip = ({ status }: ProspectStatusChipProps) => {
	const statusConfig = prospectStatusConfigMap[status];

	if (!statusConfig) return null;

	const {
		iconConfig: { color, icon },
		variant,
		label
	} = statusConfig;

	return <Chip icon={<Icon style={{ color }}>{icon}</Icon>} variant={variant as ChipProps['variant']} label={label} size="small" />;
};
